import { getMediaGroupById } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetMediaGroupByIdQuery = (groupId, enabled = true) =>
    useQuery({
        queryKey: ['media_group', groupId],
        queryFn: async () => getMediaGroupById(groupId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetMediaGroupByIdQuery;
